import React, { Fragment } from "react";
import { Link } from "gatsby";
import { Link as LinkScroll } from "react-scroll";

const CustomLink = ({ data, classNames }) => {
  return (
    <Fragment>
      {data.linkType === "slug" && (
        <Link
          className={classNames}
          to={
            data.slug?.current.startsWith("/")
              ? `${data.slug?.current}`
              : `/${data.slug?.current}`
          }
        >
          {data.linkTitle}
        </Link>
      )}
      {data.linkType === "url" && (
        <a
          className={classNames}
          href={data.url}
          target="_blank"
          rel="noreferrer"
        >
          {data.linkTitle}
        </a>
      )}
      {data.linkType === "sectionId" && (
        <LinkScroll
          className={classNames}
          to={data.sectionId}
          smooth
          duration={300}
        >
          {data.linkTitle}
        </LinkScroll>
      )}
    </Fragment>
  );
};
export const CustomLinkWithChild = ({ data, classNames, children }) => {
  return (
    <Fragment>
      {data.linkType === "slug" && (
        <Link
          className={classNames}
          to={
            data.slug.current.startsWith("/")
              ? `${data.slug.current}`
              : `/${data.slug.current}`
          }
        >
          {children}
        </Link>
      )}
      {data.linkType === "url" && (
        <a
          className={classNames}
          href={data.url}
          target="_blank"
          rel="noreferrer"
        >
          {children}
        </a>
      )}
      {data.linkType === "sectionId" && (
        <LinkScroll
          className={classNames}
          to={data.sectionId}
          smooth
          duration={300}
        >
          {children}
        </LinkScroll>
      )}
    </Fragment>
  );
};

export default CustomLink;
